module.exports = __webpack_public_path__ + "static/img/化学试剂.9d827a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/一级标题Banner/化学试剂.jpg
// module id = O1we
// module chunks = 1